/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class TestComponent {
  constructor (element) {
    this.$el = $(element)
  }
}

registerClass('TestComponent', TestComponent)
